import React from "react";
import { empiTheme } from "./styles/empiTheme";

export default function Philosophy() {
  return (
    <section id="philosophy" style={section}>
      <div style={container}>
        <div style={eyebrow}>The philosophy</div>
        <h2 style={h2}>Human-led. Intelligence-supported.</h2>

        <p style={bodyText}>
          Your body already holds information. Your mind already adapts.
        </p>

        <div style={quoteBox}>
          <p style={quoteText}>
            EmPi translates body signals and daily context into practical
            guidance you can actually use.
          </p>
        </div>

        <p style={bodyTextLast}>
          This is AI designed to support human regulation — not override it.
        </p>
      </div>
    </section>
  );
}

const section = {
  padding: empiTheme.layout.sectionPadding,
  background: empiTheme.colors.background,
};

const container = {
  maxWidth: empiTheme.layout.maxWidth,
  margin: "0 auto",
};

const eyebrow = {
  ...empiTheme.typography.eyebrow,
  color: empiTheme.colors.textSecondary,
  marginBottom: 12,
};

const h2 = {
  fontSize: empiTheme.typography.h2.fontSize,
  lineHeight: empiTheme.typography.h2.lineHeight,
  margin: "0 0 14px",
  color: empiTheme.colors.text,
  maxWidth: 760,
};

const bodyText = {
  fontSize: empiTheme.typography.body.fontSize,
  lineHeight: 1.65,
  margin: "0 0 12px",
  color: empiTheme.colors.text,
  maxWidth: 760,
};

const bodyTextLast = {
  fontSize: empiTheme.typography.body.fontSize,
  lineHeight: 1.65,
  margin: 0,
  color: empiTheme.colors.text,
  maxWidth: 760,
};

const quoteBox = {
  margin: "16px 0",
  padding: "14px 16px",
  border: `1px solid ${empiTheme.colors.border}`,
  background: "#FAFAFA",
  borderRadius: empiTheme.radius.card,
  boxShadow: empiTheme.shadow.card,
  maxWidth: 760,
};

const quoteText = {
  margin: 0,
  fontSize: 16,
  lineHeight: 1.7,
  color: empiTheme.colors.text,
};
